(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-cotizar"]) return;
  try {
    
  (function () {
    var g = document.querySelector('[data-gracias]');
    if (!g) return;
    var folio = '';
    try { folio = sessionStorage.getItem('av-folio-cotizar') || ''; } catch (e) {}
    g.querySelector('[data-folio-mostrar]').textContent = folio;
    var wa = g.querySelector('[data-folio-wa]');
    if (wa && folio) wa.href = wa.href.split('?')[0] + '?text=' + encodeURIComponent('Folio ' + folio + ' (web)');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'generate_lead', folio: folio, formulario: 'cotizar' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-ficha-serie"]) return;
  try {
    
  document.querySelectorAll('.av-ficha-serie').forEach(function (s) {
    var bs = s.querySelectorAll('.av-unidades button');
    bs.forEach(function (b) {
      b.addEventListener('click', function () {
        bs.forEach(function (x) { x.classList.toggle('on', x === b); });
        s.querySelectorAll('td[data-mm]').forEach(function (td) {
          var mm = parseFloat(td.dataset.mm);
          if (!mm) return;
          td.textContent = b.dataset.u === 'in' ? (Math.round(mm / 25.4 * 10) / 10) : mm;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-ficha"]) return;
  try {
    
  document.querySelectorAll('.av-ficha').forEach(function (f) {
    var princ = f.querySelector('.av-ficha-princ');
    f.querySelectorAll('.av-mini').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!princ) return;
        princ.removeAttribute('srcset');
        princ.src = b.dataset.src;
        f.querySelectorAll('.av-mini').forEach(function (x) { x.classList.toggle('on', x === b); });
      });
    });
    var cant = f.querySelector('.cant input');
    f.querySelectorAll('[data-cant]').forEach(function (b) {
      b.addEventListener('click', function () {
        cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.dataset.cant, 10));
      });
    });
    f.querySelectorAll('[data-copiar]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.copiar);
        var t = b.lastChild; var orig = t.textContent; t.textContent = '✓';
        setTimeout(function () { t.textContent = orig; }, 1500);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-heroe-velo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.av-heroe-velo [data-carr]').forEach(function (c) {
    if (c.dataset.listo) return;
    c.dataset.listo = '1';
    var DUR = 5000,
      sl = [].slice.call(c.querySelectorAll('.sl')),
      ds = [].slice.call(c.querySelectorAll('.carr-dots button')),
      n = c.querySelector('.carr-n'),
      t1 = c.querySelector('.carr-t1'),
      t2 = c.querySelector('.carr-t2'),
      i = 0, t = null, t0 = 0, resto = DUR, corriendo = false,
      quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (sl.length < 2) return;
    c.style.setProperty('--dur', DUR + 'ms');
    function vid() { return sl[i].querySelector('video'); }
    function cargar(s) {
      if (s.dataset.bg) { s.style.backgroundImage = 'url(' + s.dataset.bg + ')'; delete s.dataset.bg; }
      var v = s.querySelector('video');
      if (v && v.dataset.src) {
        v.src = v.dataset.src; delete v.dataset.src;
        v.addEventListener('ended', function () { if (corriendo && vid() === v) siguiente(); });
      }
    }
    function siguiente() { ir(i + 1); if (corriendo) prog(DUR); }
    function prog(ms) { clearTimeout(t); t0 = Date.now(); resto = ms; t = setTimeout(siguiente, vid() ? ms + 2500 : ms); }
    function dos(k) { return (k < 10 ? '0' : '') + k; }
    function ir(k) {
      sl[i].classList.remove('on'); if (ds[i]) ds[i].classList.remove('on');
      var v0 = vid(); if (v0) v0.pause();
      i = (k + sl.length) % sl.length; cargar(sl[i]); sl[i].classList.add('on'); resto = DUR;
      if (ds[i]) { void ds[i].offsetWidth; ds[i].classList.add('on'); }
      var v = vid();
      if (v) { try { v.currentTime = 0; } catch (e) {} if (!quieto) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      if (n) { n.textContent = dos(i + 1) + ' / ' + dos(sl.length); t1.textContent = sl[i].dataset.t1; t2.textContent = sl[i].dataset.t2; }
    }
    function play() {
      if (quieto || corriendo) return; corriendo = true; c.classList.remove('pausa');
      var v = vid(); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      prog(resto);
    }
    function stop() {
      if (!corriendo) return; corriendo = false; clearTimeout(t);
      resto = Math.max(250, resto - (Date.now() - t0));
      var v = vid(); if (v) v.pause(); c.classList.add('pausa');
    }
    ds.forEach(function (b, k) { b.addEventListener('click', function () { stop(); ir(k); play(); }); });
    c.addEventListener('mouseenter', stop);
    c.addEventListener('mouseleave', play);
    function arrancar() { sl.forEach(cargar); play(); }
    if (document.readyState === 'complete') arrancar(); else window.addEventListener('load', arrancar);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-productos"]) return;
  try {
    
  document.querySelectorAll('.av-productos form.filtro').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
    var b = f.querySelector('.av-filtro-boton');
    if (b) b.addEventListener('click', function () {
      var abierto = f.classList.toggle('abierto');
      b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
